<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img
          class="img-fluid logo-dark mb-2"
          src="@/assets/img/logo2.png"
          alt="Logo"
        />

        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Register</h1>
              <p class="account-subtitle">Access to our dashboard</p>

              <!-- Form -->
              <Form
                class="register"
                @submit="onSubmit"
                :validation-schema="schema"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label class="form-control-label">Name</label>
                  <span class="text-danger">*</span>
                  <Field
                    name="name"
                    type="text"
                    v-model="form.name"
                    class="form-control mt-2"
                    :class="{ 'is-invalid': errors.name }"
                  />
                  <div class="invalid-feedback">{{ errors.name }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Email Address</label>
                  <span class="text-danger">*</span>
                  <Field
                    name="email"
                    type="text"
                    v-model="form.email"
                    class="form-control mt-2"
                    :class="{ 'is-invalid': errors.email }"
                  />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Currency</label>
                  <span class="text-danger">*</span>
                  <Field
                    name="currency"
                    as="select"
                    v-model="form.currency"
                    class="form-control mt-2"
                    :class="{ 'is-invalid': errors.currency }"
                  >
                    <option value="" selected>Please select</option>
                    <option
                      v-for="(currency, index) in allCurrencyCodes"
                      :key="index"
                      :value="currency.code"
                    >
                      {{ `${currency.code} : ${currency.currency}` }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.currency }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Password</label>
                  <span class="text-danger">*</span>
                  <div class="pass-group">
                    <Field
                      name="password"
                      v-model="form.password"
                      :type="showPassword ? 'password' : 'text'"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span
                      v-if="!errors.password"
                      @click="toggleShow"
                      class="fas toggle-password"
                      :class="{
                        'fa-eye': showPassword,
                        'fa-eye-slash': !showPassword,
                      }"
                    ></span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Confirm Password</label>
                  <span class="text-danger">*</span>
                  <div class="pass-group">
                    <Field
                      name="confirmpassword"
                      :type="showConfirmPassword ? 'password' : 'text'"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.confirmpassword }"
                    />
                    <span
                      v-if="!errors.confirmpassword"
                      @click="toggleConfirmShow"
                      class="fas toggle-password"
                      :class="{
                        'fa-eye': showConfirmPassword,
                        'fa-eye-slash': !showConfirmPassword,
                      }"
                    ></span>
                    <div class="invalid-feedback">
                      {{ errors.confirmpassword }}
                    </div>
                    <div
                      class="emailshow text-danger"
                      id="confirmpassword"
                    ></div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form-control-label">Referral code</label>
                  <Field
                    name="referrer"
                    v-model="form.referrer"
                    type="text"
                    class="form-control pass-input mt-2"
                  />
                </div>
                <div class="form-group mb-0">
                  <button
                    class="btn btn-lg btn-block btn-primary w-100"
                    type="submit"
                    value="Register"
                    :disabled="isLoading"
                  >
                    <span
                      v-if="isLoading"
                      class="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-if="!isLoading">Register</span>
                    <span v-if="isLoading">Loading...</span>
                  </button>
                </div>
              </Form>
              <!-- /Form -->
              <div class="text-center dont-have">
                Already have an account?
                <router-link :to="{ name: 'login' }">Login</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
const currencyCodes = require("currency-codes");

// Get all currency codes
const allCurrencyCodes = computed(() => {
  return currencyCodes.data.map((currency) => currency);
});
const store = useStore();
const showConfirmPassword = ref(true);
const showPassword = ref(true);
const isLoading = ref(false);
const password = ref(null);

const toggleConfirmShow = () => {
  showConfirmPassword.value = !showConfirmPassword.value;
};
const toggleShow = () => {
  showPassword.value = !showPassword.value;
};

const form = ref({
  name: "",
  email: "",
  password: "",
  currency: "",
  referrer: "",
});

const schema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().required("Email is required").email("Email is invalid"),
  currency: Yup.string().required("Currency is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmpassword: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords do not match"),
});
const onSubmit = () => {
  isLoading.value = true;
  store
    .dispatch("auth/register", form.value)
    .then(() => {
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
    });
};
</script>
